import logo from './logo.svg';
import './index.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Model from "./pages/Model";

import { useEffect, useState } from 'react';

function App() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();


      const userDismissed = localStorage.getItem('pwaInstallDismissed');

      if (!userDismissed) {
        setDeferredPrompt(e);
        setShowInstallPrompt(true);
      }
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
    };
  }, []);

  const handleInstallClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt(); // Show browser install dialog
      const { outcome } = await deferredPrompt.userChoice;
      console.log(`User response: ${outcome}`);
      setDeferredPrompt(null);
      setShowInstallPrompt(false);
    }
  };

  const handleCancelClick = () => {
    localStorage.setItem('pwaInstallDismissed', 'true');
    setShowInstallPrompt(false);
  };


  return (
    <div>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/model/:id/:title" element={<Model />} />
        </Routes>
      </Router>

      {showInstallPrompt && (
        <div className="fixed bottom-4 right-4 bg-white shadow-lg p-4 rounded-lg border z-50">
          <p>Install this Express Analytics app for a better experience!</p>

          <div className="flex justify-end gap-2">
            <button
              className="px-4 py-1 bg-gray-200 text-gray-800 rounded hover:bg-gray-300"
              onClick={handleCancelClick}
            >
              Cancel
            </button>
            <button
              className="px-4 py-1 bg-blue-600 text-white rounded hover:bg-blue-700"
              onClick={handleInstallClick}
            >
              Install
            </button>
          </div>
        </div>
      )}
    </div>
  );
}


export default App;
